// Sanitize raw HTML embed code pasted by the admin (SoundCloud / YouTube iframes).
// Only iframes from a strict allowlist of hosts pass through; everything else is stripped.
import DOMPurify from "dompurify";

const ALLOWED_IFRAME_HOST_PATTERNS = [
  /^https?:\/\/(w\.)?soundcloud\.com\//i,
  /^https?:\/\/(www\.)?youtube(-nocookie)?\.com\//i,
  /^https?:\/\/(www\.)?youtu\.be\//i,
];

// Allow iframes only when their src matches the allowlist.
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName !== "iframe") return;
  const src = node.getAttribute && node.getAttribute("src");
  if (!src || !ALLOWED_IFRAME_HOST_PATTERNS.some((re) => re.test(src))) {
    node.parentNode && node.parentNode.removeChild(node);
  }
});

const CONFIG = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: [
    "allow",
    "allowfullscreen",
    "frameborder",
    "scrolling",
    "loading",
    "referrerpolicy",
    "title",
  ],
};

export function sanitizeEmbed(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, CONFIG);
}
